"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.start = start;
const js_1 = __importDefault(require("@bugsnag/js"));
const constants_1 = require("next/dist/shared/lib/constants");
function start() {
    if (process.env.NEXT_PHASE !== constants_1.PHASE_PRODUCTION_BUILD) {
        if (!process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
            console.warn('NEXT_PUBLIC_BUGSNAG_API_KEY is not set');
            return;
        }
        js_1.default.start({
            apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
            appVersion: process.env.NEXT_BUILD_ID,
            plugins: []
        });
    }
}
//# sourceMappingURL=index.js.map